import { getKeyFieldY } from '@components/TimeLineGrid/helpers/getKeyFieldY'

import { TimeLineDTOType } from '@types'

export const getFilterParamForObjectY = ({
  config,
  objectYKeyFieldsValues,
}: {
  config: TimeLineDTOType
  objectYKeyFieldsValues?: unknown[]
}): string | undefined => {
  let result = ''

  const objectYKeyField = getKeyFieldY(config)

  if (config.objectY.preFilter) {
    result += config.objectY.preFilter
  }

  if (objectYKeyFieldsValues?.length) {
    // Экранируем кавычки в значениях (если это строки)
    const escapedKeyFieldValues = objectYKeyFieldsValues
      .map(keyFieldValue => `"${keyFieldValue}"`)
      .join(',')
    const objectYKeyFieldValuesFilter = `${objectYKeyField}=in=(${escapedKeyFieldValues})`

    result += result ? `;${objectYKeyFieldValuesFilter}` : objectYKeyFieldValuesFilter
  }

  return result
}
